import { config } from "md-editor-rt";
// ─────────────────────────────────────────────────────────────
// Iframe Plugin (same as before)
const iframePlugin = (md, iframeConfig) => {
  function tokenize(state, silent) {
    const pos = state.pos;
    const marker = "::iframe[";
    if (state.src.slice(pos, pos + marker.length) !== marker) return false;
    const start = pos + marker.length;
    const end = state.src.indexOf("]", start);
    if (end === -1) return false;
    const url = state.src.slice(start, end).trim();
    if (!url) return false;
    if (!silent) {
      const token = state.push("iframe", "", 0);
      token.content = url;
    }
    state.pos = end + 1;
    return true;
  }
  md.inline.ruler.before("link", "iframe", tokenize);
  md.renderer.rules.iframe = function (tokens, idx) {
    const url = tokens[idx].content;
    let provider = null;
    for (const key in iframeConfig) {
      if (url.includes(key)) {
        provider = iframeConfig[key];
        break;
      }
    }
    if (!provider || provider.disabled) {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    }
    let embedUrl = url;
    if (provider.replace) {
      provider.replace.forEach(([find, replace]) => {
        embedUrl = embedUrl.replace(find, replace);
      });
    }
    if (provider.removeAfter) {
      const index = embedUrl.indexOf(provider.removeAfter);
      if (index !== -1) {
        embedUrl = embedUrl.slice(0, index);
      }
    }
    const width = provider.width || 560;
    const height = provider.height || 315;
    const tag = provider.tag || "iframe";
    return `<${tag} width="${width}" height="${height}" src="${embedUrl}" frameborder="0" allowfullscreen></${tag}>`;
  };
};

const iframeConfig = {
  "www.youtube.com": {
    tag: "iframe",
    width: 560,
    height: 315,
    disabled: false,
    replace: [
      ["watch?v=", "embed/"],
      ["http://", "https://"],
    ],
    removeAfter: "&",
  },
  "youtu.be": {
    tag: "iframe",
    width: 560,
    height: 315,
    disabled: false,
    replace: [
      ["youtu.be/", "www.youtube.com/embed/"],
      ["http://", "https://"],
    ],
    removeAfter: "&",
  },
  "vimeo.com": {
    tag: "iframe",
    width: 640,
    height: 360,
    disabled: false,
    replace: [
      ["vimeo.com/", "player.vimeo.com/video/"],
      ["http://", "https://"],
    ],
    removeAfter: "?",
  },
  "player.vimeo.com": {
    tag: "iframe",
    width: 640,
    height: 360,
    disabled: false,
  },
};

// ─────────────────────────────────────────────────────────────
// Configure markdown-it via md-editor-rt’s config API
export const mdEditorConfig = () => {
  return config({
    markdownItConfig: (md) => {
      const defaultLinkRender =
        md.renderer.rules.link_open ||
        function (tokens, idx, options, env, self) {
          return self.renderToken(tokens, idx, options);
        };
      md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
        const token = tokens[idx];
        const classAttr = token.attrGet("class") || "";
        if (!classAttr.includes("anchor")) {
          token.attrSet("target", "_blank");
          token.attrSet("rel", "noopener noreferrer");
        }
        return defaultLinkRender(tokens, idx, options, env, self);
      };
      // Use the custom iframe plugin
      md.use(iframePlugin, iframeConfig);
    },
  });
};

export default mdEditorConfig;
